// extracted by mini-css-extract-plugin
export default {"staticBanner":"StaticBanner_staticBanner__VqVr8"};